import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalProfile } from "../local/useLocalProfile";
import { loadPlayerFromServer } from "../local/playerAccount";

/** Cross-device sign-in: enter a 4-digit player code and pull the saved
 *  profile down from the server. */
export function LocalLogin() {
  const nav = useNavigate();
  const { setProfile } = useLocalProfile();
  const [code, setCode] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const c = code.trim();
    if (!/^\d{4}$/.test(c)) {
      setErr("Enter your 4-digit code.");
      return;
    }
    setBusy(true);
    setErr(null);
    try {
      const profile = await loadPlayerFromServer(c);
      if (!profile) {
        setErr("No player with that code. Check the digits.");
        return;
      }
      // Force the code in case the stored copy didn't have it.
      setProfile({ ...profile, code: c });
      nav("/", { replace: true });
    } catch {
      setErr("Couldn't reach server. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="home-dashboard create-page">
      <div className="create-panel stack t-center" style={{ maxWidth: 460 }}>
        <h1>Log in</h1>
        <p className="t-muted" style={{ marginTop: -8 }}>
          Enter your 4-digit player code.
        </p>
        <input
          className="input"
          autoFocus
          value={code}
          inputMode="numeric"
          pattern="\d*"
          maxLength={4}
          onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, "").slice(0, 4))}
          placeholder="1234"
          style={{
            textAlign: "center",
            fontSize: "2.4rem",
            letterSpacing: "0.6rem",
            fontWeight: 900,
          }}
        />
        {err && <div className="error t-center">{err}</div>}
        <button
          className="btn btn-primary btn-big btn-block"
          onClick={submit}
          disabled={busy || code.length !== 4}
        >
          {busy ? "Loading…" : "Log in →"}
        </button>
        <button className="btn btn-ghost btn-block" onClick={() => nav("/")}>
          ← Back
        </button>
      </div>
    </div>
  );
}
